import { render, staticRenderFns } from "./feature-version-validator.vue?vue&type=template&id=6b89252a&"
import script from "./feature-version-validator.vue?vue&type=script&lang=ts&"
export * from "./feature-version-validator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports